export const DATETIME_FORMAT_SERVER_UTC = "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]";
export const DATE_FORMAT_SERVER_UTC = "YYYY-MM-DD";
export const DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT = "DD MMM YYYY  HH:mm:ss";
export const DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT_SHORT_TIME = "DD MMM YYYY  HH:mm";

export const DATETIME_FORMAT_DISPLAY_LOCAL_KENDO = "MM/dd/yyyy-HH:mm:ss";
export const DATE_FORMAT_DISPLAY_LOCAL_MOMENT = "DD MMM YYYY";
export const TIME_FORMAT_DISPLAY_LOCAL_MOMENT = "HH:mm:ss";
export const TIME_FORMAT_DISPLAY_LOCAL_MOMENT_SHORT = "HH:mm";
export const TIME_FORMAT_DISPLAY_LOCAL_MOMENT_HOUR = "hA";
export const DATETIME_FORMAT_COMPANY_CHAT_MOMENT = "DD MMM HH:mm:ss";

export const DEFAULT_KENDOUI_DATETIMEPICKER_DATE_FORMAT = "yyyy-MM-dd";
export const SUMMARY_DEFAULT_KENDOUI_GRID_DATE_FORMAT = "{0:dd MMM yyyy}";

export const DEFAULT_KENDOUI_GRID_DATETIME_FORMAT = "{0:dd MMM  HH:mm:ss}";
export const DEFAULT_KENDOUI_GRID_TIME_FORMAT_SHORT = "{HH:mm}";
export const DEFAULT_KENDOUI_GRID_TIME_FORMAT_HOUR = "{hA}";

export const SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT = "{0:dd MMM yyyy  HH:mm}";
export const SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT2 = "{0:MM/dd/yyyy  HH:mm}";
export const SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT3 = "dd MMM yyyy  HH:mm";
export const SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT4 = "{0:dd MMM yyyy  HH:mm:ss}";

export const CASE_REPORT_GENERAL_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT3;
export const CASE_REPORT_IN_PROGRESS_KENDOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
export const CASE_REPORT_OFFICER_KENDOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT4;
export const CASE_REPORT_PERSON_KENDOUI_GRID_DATE_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATE_FORMAT;
export const CASE_REPORT_GENERAL_LAST_ATE_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT3;
export const CASE_REPORT_OFFICER_KENDOUI_GRID_DATETIME_FORMAT_MOMENT = DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT;

export const CALL_CARD_GENERAL_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
export const CALL_CARD_DATETIMEPICKER_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT3;
export const CALL_CARD_IN_PROGRESS_KENDOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
export const CALL_CARD_OFFICER_KENDOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT4;
export const CALL_CARD_OFFICER_KENDOUI_GRID_DATETIME_FORMAT_MOMENT = DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT;
export const CALL_CARD_CALL_DATE_TIME_FORMAT_MOMENT = DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT;
export const CALL_CARD_PERSON_DOB_DATE_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATE_FORMAT;

export const IN_PROGRESS_CALLS_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
export const IN_PROGRESS_OFFICERS_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;

export const NPSD_REPORTS_INVOLVING_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
export const NPSD_AUDIT_LOG_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;

export const SEARCH_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
export const SEARCH_DOB_DOUI_GRID_DATE_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATE_FORMAT;

export const GENERAL_LOG_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
export const NPSD_LOG_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
export const REPORT_LOG_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;

export const ADMIN_USERMANAGEMENT_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;

export const NPSD_DATEONLY_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATE_FORMAT;
export const USERPROFILE_HIREDATE_DOUI_GRID_DATETIME_FORMAT = SUMMARY_DEFAULT_KENDOUI_GRID_DATE_FORMAT;

export const SEARCH_PERSON_DATE_FORMAT = DATE_FORMAT_DISPLAY_LOCAL_MOMENT;
export const SEARCH_CALLCARD_BY_NPSD_DATA = SUMMARY_DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;


// Window registrations
(window as any).DATETIME_FORMAT_SERVER_UTC = DATETIME_FORMAT_SERVER_UTC;
(window as any).DATE_FORMAT_DISPLAY_LOCAL_MOMENT = DATE_FORMAT_DISPLAY_LOCAL_MOMENT;
(window as any).DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT = DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT;
(window as any).TIME_FORMAT_DISPLAY_LOCAL_MOMENT = TIME_FORMAT_DISPLAY_LOCAL_MOMENT;
(window as any).DEFAULT_KENDOUI_GRID_DATETIME_FORMAT = DEFAULT_KENDOUI_GRID_DATETIME_FORMAT;
